var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorkspace1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_794_935)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.1076 13.375H11.8926V17.1238H20.1076V13.375Z",
    fill: "#494949"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5669 17.1238L24.7331 12.1231C24.3225 9.66125 22.2131 7.875 19.7181 7.875H19.2869C20.1137 7.03937 20.625 5.89062 20.625 4.625C20.625 2.075 18.55 0 16 0C13.45 0 11.375 2.075 11.375 4.625C11.375 5.89062 11.8862 7.03937 12.7131 7.875H12.2819C9.78623 7.875 7.67748 9.66125 7.26686 12.1231L6.43311 17.1238H10.0175V11.5H21.9825V17.1238H25.5669Z",
    fill: "#494949"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.28174 18.9988V23.1869H3.62543V32H28.3743V23.1869H30.718V18.9988H1.28174Z",
    fill: "#3A57FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_794_935"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkspace1);
export default __webpack_public_path__ + "static/media/Workspace 1.7698f60d21d7af15968610535d353a82.svg";
export { ForwardRef as ReactComponent };